import React from 'react';
import { Button, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { AppstoreAddOutlined, ClearOutlined, ThunderboltOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface PlantingModeContentProps {
  isBusy: boolean;
  isEraseMode: boolean;
  multiSelectedBeds: Set<string>;
  isBulkPlacementMode?: boolean;
  bulkGridDimensions?: { rows: number; cols: number } | null;
  onToggleEraseMode: () => void;
  onOpenBulkPlacementModal?: () => void;
  onCancelBulkPlacement?: () => void;
  onBatchAction?: () => void;
}

const PlantingModeContent: React.FC<PlantingModeContentProps> = ({
  isBusy,
  isEraseMode,
  multiSelectedBeds,
  isBulkPlacementMode,
  bulkGridDimensions,
  onToggleEraseMode,
  onOpenBulkPlacementModal,
  onCancelBulkPlacement,
  onBatchAction,
}) => {
  const { t } = useTranslation('planning');
  if (isBulkPlacementMode && bulkGridDimensions) {
    return (
      <Space>
        <Text type="success">{t('plantingMode.placementMode', { rows: bulkGridDimensions.rows, cols: bulkGridDimensions.cols })}</Text>
        <Text type="secondary">{t('plantingMode.placementHint')}</Text>
        <Button danger icon={<CloseOutlined />} onClick={onCancelBulkPlacement}>{t('common:actions.cancel')}</Button>
      </Space>
    );
  }

  return (
    <Space wrap>
      <Button type="primary" icon={<AppstoreAddOutlined />} onClick={onOpenBulkPlacementModal} disabled={isBusy}>{t('plantingMode.bulkPlacement')}</Button>
      <Button type={isEraseMode ? 'primary' : 'default'} danger={isEraseMode} icon={<ClearOutlined />} onClick={onToggleEraseMode} disabled={isBusy}>{t('plantingMode.erase')}</Button>
      {onBatchAction && multiSelectedBeds.size > 0 && (
        <Button type="primary" icon={<ThunderboltOutlined />} onClick={onBatchAction} disabled={isBusy} style={{ background: '#52c41a', borderColor: '#52c41a' }}>
          {t('plantingMode.batchAction', { count: multiSelectedBeds.size })}
        </Button>
      )}
      {!isEraseMode && multiSelectedBeds.size === 0 && <Text type="secondary" style={{ marginLeft: 8 }}>{t('plantingMode.multiSelectHint')}</Text>}
      {isEraseMode && <Text type="warning">{t('plantingMode.eraseHint')}</Text>}
    </Space>
  );
};

export default PlantingModeContent;
